import { combineReducers } from "redux";
import authReducer from "./authReducer";
import AnalyticsReducer from "./analyticsReducer";

const RootReducer = combineReducers({
    auth: authReducer,
    analytics:AnalyticsReducer
});

export default RootReducer;